<template>
   <p>Congratulations! You have completed the onboarding process.</p>
   <p>
      It takes up to 24 hours for your data to be processed and available in
      your project.
   </p>
   <p>Check back tomorrow to see your dashboard.</p>
</template>
<script lang="ts" setup>
import { getOrg } from "@/services/clerk"
import { useAnalyticsStore } from "@/stores/analyticsStore"
import { useProjectStore } from "@stores/projectStore"
import { onMounted } from "vue"
import { useRouter } from "vue-router"
const analyticsStore = useAnalyticsStore()
const router = useRouter()
const projectStore = useProjectStore()

onMounted(async () => {
   await analyticsStore.fetchOverview()
   if (analyticsStore.overview) {
      const org = await getOrg()
      router.push({
         name: "ProjectHome",
         params: {
            orgSlug: org?.slug,
            projectId: projectStore.projectId,
         },
      })
   }
})
</script>
